export default "__VITE_ASSET__DYYxhghj__"